import styled from 'styled-components';
import { Layout } from 'antd';

export const StyledLayout = styled(Layout)`
  background-color: #fff;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  display: block;
  width: 100%;
  margin: 2rem 0 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  color: #000;
  padding: 0 0.2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin: 1.5rem 0 0;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
    margin: 1rem 0 0;
  }
`;
